import translations from '../files/pt-BR.json';
export const locale = {
  lang: 'pt-BR',
  data: Object.assign({}, translations),
};

